/**
 * Function to convert 24hr time to UTC based on a specific time zone
 * @param {any} time - Time in 24-hour format (e.g., "14:30")
 * @param {any} dateString - Optional date string to use instead of current date
 * @returns {any} - Date in UTC as a string in ISO format
 */
const ConvertToUTC = (time: string, dateString?: string) => {
  if (time) {
    let year: number;
    let month: number;
    let day: number;

    if (dateString) {
      // Split the dateString (assuming format YYYY-MM-DD)
      const dateParts = dateString.split('-');
      if (dateParts.length === 3) {
        year = Number(dateParts[0]);
        month = Number(dateParts[1]) - 1; // 0-indexed month
        day = Number(dateParts[2]);
      } else {
        // Fallback to parsing with new Date
        const temporaryDate = new Date(dateString);
        year = temporaryDate.getUTCFullYear();
        month = temporaryDate.getUTCMonth();
        day = temporaryDate.getUTCDate();
      }
    } else {
      const now = new Date();
      year = now.getFullYear();
      month = now.getMonth();
      day = now.getDate();
    }

    // Split the time string into hours and minutes
    const [hours, minutes] = time.split(':').map(Number);

    // Create a date object using local date and time components, which converts it to UTC
    const date = new Date(year, month, day, hours, minutes);

    // Return the date in ISO string format (UTC)
    return date.toISOString(); // returns in 'YYYY-MM-DDTHH:mm:ssZ' format
  }
  return '';
};

export default ConvertToUTC;
